export default __webpack_public_path__ + "static/media/ProPublica-monogram-color.b9f27bc8.svg";